(() => {
  const ADS_TAG_ID = 'AW-864452990';
  const LEAD_CONVERSION = 'AW-864452990/Sco6CKnS-pgdEP6CmpwD';
  const PHONE_CLICK_CONVERSION = 'AW-864452990/xoUFCLPvwZ0dEP6CmpwD';
  const EMAIL_CLICK_CONVERSION = 'AW-864452990/NRF_CJ7Jyp0dEP6CmpwD';
  let tagLoaded = false;
  let leadTracked = false;
  let privacyAttempts = 0;

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function marketingAllowed() {
    const privacy = customerPrivacy();
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return false;
    try {
      return privacy.marketingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function updateConsent(allowed) {
    window.gtag('consent', 'update', {
      ad_storage: allowed ? 'granted' : 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
  }

  function loadAdsTag() {
    if (!marketingAllowed()) {
      if (tagLoaded) updateConsent(false);
      return false;
    }
    if (tagLoaded) {
      updateConsent(true);
      return true;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    window.gtag('js', new Date());
    updateConsent(true);
    window.gtag('config', ADS_TAG_ID, { send_page_view: false });

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ADS_TAG_ID);
    document.head.appendChild(script);
    tagLoaded = true;
    return true;
  }

  function trackSuccessfulLead() {
    if (leadTracked || !document.querySelector('[data-contact-success]')) return;
    if (!loadAdsTag()) return;
    leadTracked = true;
    window.gtag('event', 'conversion', { send_to: LEAD_CONVERSION });
  }

  function trackContactClick(event) {
    const link = event.target && event.target.closest
      ? event.target.closest('a[href]')
      : null;
    if (!link || !marketingAllowed()) return;

    const href = (link.getAttribute('href') || '').trim().toLowerCase();
    let conversion;
    if (href.startsWith('tel:')) {
      conversion = PHONE_CLICK_CONVERSION;
    } else if (href.startsWith('mailto:')) {
      conversion = EMAIL_CLICK_CONVERSION;
    } else {
      return;
    }

    if (!loadAdsTag()) return;
    window.gtag('event', 'conversion', { send_to: conversion });
  }

  function syncConsentAndLead() {
    loadAdsTag();
    trackSuccessfulLead();
  }

  // Shopify loads the privacy API asynchronously. A success page must also be
  // checked once it is ready, and after a visitor changes their consent.
  function initializePrivacy() {
    const privacy = customerPrivacy();
    if (privacy && typeof privacy.marketingAllowed === 'function') {
      syncConsentAndLead();
      return;
    }

    const shopify = window.Shopify;
    if (shopify && typeof shopify.loadFeatures === 'function') {
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function(error) {
          if (!error) syncConsentAndLead();
        });
      } catch (error) {
        // Never assume consent if Shopify's privacy API cannot be loaded.
      }
      return;
    }

    // Bounded wait for Shopify's own loader; no ongoing polling.
    privacyAttempts += 1;
    if (privacyAttempts < 40) window.setTimeout(initializePrivacy, 250);
  }

  document.addEventListener('visitorConsentCollected', syncConsentAndLead);
  document.addEventListener('click', trackContactClick);
  initializePrivacy();
})();